/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(t){this._statistics=t}get statistics(){return this._statistics}}export{t as AAggregateCell};
